
export const CustomInputField = ({name, value, setValue}) => {
    return (
        <>
            <div className="col-12 col-lg-6">
                <h5>{name}</h5>
                <div className="card">
                    <div className="card-body pa-5">
                        <input
                            type="email"
                            className="form-control"
                            defaultValue={value}
                            onChange={setValue}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}